import { useMediaQuery, useTheme } from '@mui/material';
import { PageContentsItem } from '@/types/generated';
import { getComponentMapByTheme } from './componentMap';
import { useAppContext } from '@shared-components/context/AppContextProvider.ctx';
import { getLogger } from '@shared-components/logging/logger';
import { TDisplayScreen } from '@shared-components/types';
import { canDisplayContentOnScreen } from '@utils';
export type ComponentProps = PageContentsItem & {
  // any common props for all components
  display?: TDisplayScreen;
  variant?: string;
};
interface Props {
  componentProps: ComponentProps;
  typename: string;
  tags?: Array<string>;
}
const logger = getLogger('design-system');
export const ComponentResolver = ({
  typename,
  componentProps,
  tags
}: Props) => {
  const {
    variant
  } = componentProps;
  const {
    config
  } = useAppContext();
  const {
    themeId
  } = config;
  const componentsMap = getComponentMapByTheme(themeId, variant || '');
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const shouldDisplayContent = canDisplayContentOnScreen(isSmallScreen, componentProps?.display);
  if (!shouldDisplayContent) {
    logger.debug(`Not displaying ${typename} for current screen size`);
    return null;
  }
  const Component = componentsMap[typename] as unknown as React.ComponentType<any>;
  if (!Component) {
    logger.debug(`No Template Component for ${typename}`);
    return null;
  }
  logger.debug(`Created ${typename} ${componentProps?.sys.id}`);
  return <Component {...componentProps} tags={tags} variant={variant} data-sentry-element="Component" data-sentry-component="ComponentResolver" data-sentry-source-file="ComponentResolver.tsx" />;
};